import React from 'react'
import {
    Link,
  } from "react-router-dom";

export const Crm = (props) => {
    return (
        <div>
            <div className="container">

                <h3 className="mt-4 mb-3" style={{fontFamily: 'effraReg'}}>BronzeTag CRM
            
                </h3>

                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <Link to="/">Home</Link>
                    </li>
                    <li className="breadcrumb-item active" style={{fontFamily: 'effraReg'}}>CRM</li>
                </ol>

                <div className="row">
                    <div class="col-lg-12">
                        <p style={{fontFamily: 'effraReg'}}>BronzeTag POS gives your business the tools needed to manage your customers, track their sales and activity, and keep them hooked with loyalty programs, coupons, discounts and promotions.</p>
                    </div>
                </div>

                <div className="row">
                    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', paddingLeft: 64}}>
                        <span style={{fontFamily: 'effraReg'}}>Sales promotions.</span>
                        <span style={{fontFamily: 'effraReg'}}>Manufacturer coupons.</span>
                        <span style={{fontFamily: 'effraReg'}}>Instore coupons.</span>
                        <span style={{fontFamily: 'effraReg'}}>Discounts.</span>
                        <span style={{fontFamily: 'effraReg'}}>Active and inactive customers reports.</span>
                        
                    </div>
                    
                </div>
            

            </div>
        </div>
    )
}